export default {
  headerContent: {
    title: 'Türkiye Sigorta Zorunlu Deprem Sigortası (DASK) Fiyatları',
    slogan: "Zorunlu Deprem Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'DASK TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Türkiye Sigorta DASK',
    description: {
      title:
        'Türkiye Sigorta DASK (Zorunlu Deprem Sigortası) Nedir? DASK Ne Demek? ',
      content: [
        'Türkiye Sigorta zorunlu deprem sigortası ürünü deprem sonucunda oluşacak finansal kayıplara karşı koruma sunmaktadır.'
      ]
    },
    subContent: {
      title: 'Türkiye Sigorta Zorunlu Deprem Sigortası ZDS Teminatları Neler?',
      content: [
        {
          paragraph:
            '',
          subList: [
            'Deprem sonrası maddi zarar,',
            'Deprem sonrası yangın,',
            'Deprem sonrası infilak,',
            'Deprem sonrası tsunami,',
            'Deprem sonrası yer kayması teminatından oluşmaktadır.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'DASK Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'DASK Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'DASK Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'DASK Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'DASK Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Türkiye Sigorta DASK Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title:
        'Türkiye Sigorta Zorunlu Deprem Sigortası Teminat Dışı Kalan Haller Nelerdir?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortası genel şartları gereğince teminat dışı kalan haller;',
          subList: [
            'Alternatif ikametgah ve işyeri masrafları',
            'Deprem ve deprem sonucu oluşan yangın, infilak, tsunami veya yer kaymasının dışında kalan hasarlar',
            'Depremden bağımsız olarak, binanın kendi kusurlu yapısı nedeniyle zamanla oluşmuş zararlar',
            'Enkaz kaldırma masrafları',
            'Her türlü taşınır mal, eşya ve benzerleri',
            'İş durması',
            'Kar kaybı',
            'Kira mahrumiyeti',
            'Mali sorumluluklar ve benzeri başkaca ileri sürülebilecek diğer bütün dolaylı zararlar',
            'Manevi tazminat talepleri',
            'Tüm bedeni zararlar ve vefat.'
          ]
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta İle Hangi Binalar Zorunlu Deprem Sigortası Kapsamındadır?',
      content: [
        {
          paragraph:
            'Genel şartlarda belirtilmiş binalar hariç tüm binalar kapsam dahilindedir.',
          subList: null
        },
        {
          paragraph:
            'Bu binalar;',
          subList: [
            'Tapuya kayıtlı ve özel mülkiyete tabi taşınmazlar üzerinde mesken olarak inşa edilmiş binalar',
            '634 sayılı Kat Mülkiyeti Kanunu kapsamındaki bağımsız bölümler',
            'Bu binaların içinde yer alan ve ticarethane, büro ve benzeri amaçlarla kullanılan bağımsız bölümler',
            'Doğal afetler nedeniyle devlet tarafından yaptırılan veya verilen kredi ile yapılan meskenler.',
            'Zorunlu Deprem Sigortası ayrıca yukarıdaki koşullara uyan;',
            'Kat irtifakı tesis edilmiş binalar',
            'Tapuda henüz cins tashihi yapılmamış ve tapu kütüğünde vasfı "arsa vs." olarak görünen binalar',
            'Tapu tahsisi henüz yapılmamış kooperatif evleri'
          ]
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Zorunlu Deprem Sigortası Kapsamında Yer Alan Konut Bölümleri Nelerdir?',
      content: [
        {
          paragraph:
            'Deprem sigortası genel şartlarına göre kapsam altında olan bölümler;',
          subList: [
            'Temeller',
            'Ana duvarlar',
            'Bağımsız bölümleri ayıran ortak duvarlar',
            'Bahçe duvarları',
            'İstinat duvarları',
            'Tavan ve tabanlar',
            'Merdivenler',
            'Asansörler',
            'Sahanlıklar',
            'Koridorlar',
            'Çatılar',
            'Bacalar',
            'Yapının yukarıdakilerle benzer nitelikteki tamamlayıcı bölümlerinden oluşmaktadır.'
          ]
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Hangi Binalar Genel Şartlar Gereğince Zorunlu Deprem Sigortası Kapsamında Değildir?',
      content: [
        {
          paragraph:
            'Zorunlu Deprem Sigortası kapsamı dışında kalan bina türleri aşağıdaki gibidir:',
          subList: [
            '9/11/1983 tarihli ve 2946 sayılı Kamu Konutları Kanununa tâbi olan veya kamu hizmet binası olarak kullanılan binalar ve bağımsız bölümler',
            'Köy nüfusuna kayıtlı ve köyde sürekli oturanlarca köy yerleşik alanları ve civarında ve mezralarda yapılan binalar',
            'Tamamı ticari veya sınai amaçla kullanılan binalar',
            'Projesi bulunmayan ve mühendislik hizmeti görmemiş binalar',
            'Taşıyıcı sistemi olumsuz yönde etkileyecek şekilde tadil edildiği veya zayıflatıldığı tespit edilen binalar',
            'Taşıyıcı sistemi olumsuz yönde etkileyecek şekilde ilgili mevzuata ve projeye aykırı olarak inşa edilen binalar',
            'Yetkili kamu kurumları tarafından yıkılmasına karar verilen binalar ile mesken olarak kullanıma uygun olmayan, bakımsız, harap veya metruk binalar',
            'ZDS kapsamı dışındaki binalara, İhtiyari Deprem Sigortası yaptırabilirsin.',
            'Köy yerleşimleri -genel olarak gelir düzeyinin düşük olması, binalarda belediye denetiminin bulunmaması ve sigortanın sunumunun zor olması gibi nedenlerle- sigorta kapsamı dışında yer alır. Ancak, köylerde bulunan yapılar için istendiği takdirde İhtiyari Deprem Sigortası yaptırılması mümkündür. Benzer şekilde ticari ve sanayi amaçlar için kullanılan binalar için de İhtiyari Deprem Sigortası yaptırılabilir.'
          ]
        }
      ]
    },
    {
      title:
        'Tapu Olmadan Türkiye Sigorta Zorunlu Deprem Sigortası Yapılıyor Mu?',
      content: [
        {
          paragraph:
            'Tapu olamadan DASK sigortası yapılmaktadır. Tapuda yazan ada, pafta, parsel gibi bilgileri bilmeniz yeterlidir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta DASK Olmadan Elektrik Aboneliği Açılır Mı?',
      content: [
        {
          paragraph:
            'DASK sigortası olmadan elektrik aboneliği verilememektedir. Yalnızca elektrik değil doğalgaz ve su abonelikleri de açılmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Zorunlu Deprem Sigortasında Eşyalar Teminat Kapsamında Mı?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortası sadece binanın kaba inşaatını kapsamaktadır. Eşya veya özel dekorasyonlar teminat dahilinde değildir. Konut içerisinde bulunan eşyalar için konut sigortası kaptırabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta DASK Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortasını Türkiye sigortadan almak için bizimle iletişime geçebilirsiniz. Alokasko.com olarak ilettiğiniz bilgiler doğrultusunda size özel olarak sunulan teklifleri karşılaştırarak size sunmaktayız. Sizden gelen onay doğrultusunda poliçenizi tanzim etmekteyiz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta DASK İçin Nereye Başvurulur?',
      content: [
        {
          paragraph:
            'Deprem sigortanızı yaptırmak için alokasko.com üzerinden başvuru formu doldurabilir veya telefon yoluyla uzman danışmanlarımızla iletişime geçebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta DASK İçin Gerekli Belgeler (Evraklar) Nelerdir?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortası için gerekli bilgiler;',
          subList: [
            'Sigortalının vergi ve T.C. kimlik numarası',
            'Sigortalanacak yerin açık adresi',
            'Binanın inşa yılı',
            'Binanın yapı tarzı',
            'Binanın kaç katlı olduğu',
            'Binanın hasar durumu',
            'Konutun brüt yüz ölçümü (m²)',
            'Konutun kullanım şekli. '
          ]
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta DASK Yangını Kapsar Mı?',
      content: [
        {
          paragraph:
            'Dask sigortası deprem sonucu çıkan yangından dolayı oluşan hasarları kapsamaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta DASK İle Konut Sigortası Arasındaki Fark Nedir?',
      content: [
        {
          paragraph:
            'Deprem sigortası konut sigortasının aksine zorunlu bir sigorta üründür. ',
          subList: null
        },
        {
          paragraph:
            'Deprem sigortası konut sigortasına göre daha uygun fiyatlıdır. Bunun nedeni ise deprem sigortasının teminatlarının konut sigortası teminatlarından daha dar olmasıdır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Zorunlu Deprem Sigortası Yaptırmadan Konut Poliçesi Yaptırmak Mümkün Mü?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortası olamadan konut poliçesi alabilirsiniz. Fakat deprem sonucunda oluşan hasarlar kapsam dışı sayılacaktır. Deprem harici hasarlarınızda konut sigortanızdan faydalanabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Zorunlu Deprem Sigortasında Tazminat Ödenmesi Ne Şekilde Olur?',
      content: [
        {
          paragraph:
            'Tazminat ödemesi tazminat miktarının belirlenmesinin ardından Doğal Afet Sigortaları Kurumu tarafından poliçede yazan bedeli aşmamak kaydıyla en geç bir ay içerisinde hak sahibine yapılmaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta DASK (Zorunlu Deprem Sigortası) İptali Yapılır Mı?',
      content: [
        {
          paragraph:
            'Dask sigortası iptal edilememektedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta DASK (Zorunlu Deprem Sigortası) Hasar İhbarı Nereye Yapılır?',
      content: [
        {
          paragraph:
            'Hasar ihbarınızı isterseniz sigorta şirketlerine veya Alo 125 hattına bildirilebilir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta DASK (Poliçe) Sorgulama Nereden Yapılır?',
      content: [
        {
          paragraph:
            'Dask sigortanızın sorgulamasını dask.gov.tr den yapabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta DASK (Zorunlu Deprem Sigortası) Teklifi Almak İçin Ne Yapılır?',
      content: [
        {
          paragraph:
            'Dask sigortası teklifi almak için başvuru formunda yer alan gerekli bilgileri iletmeniz yeterli olacaktır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta DASK Ne Kadar Ödeme Yapar?',
      content: [
        {
          paragraph:
            'Dask sigortası tazminat ödemeleri poliçede yazan bina bedeli aşmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Deprem Sigortası Nerede Yapılır?',
      content: [
        {
          paragraph:
            'Dask sigortanızı alokasko aracılığı ile yaptırabilirsiniz. Bunun için yapmanız gereken alokasko.com üzerinde yer alan başvuru formunu doldurmanızdır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta DASK (Poliçe) Hesaplama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Dask sigortası yapının tarzı, hasarsızlık durumu gibi etkenler göz ününde bulundurularak yapılmaktadır. ',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta DASK Zorunlu Deprem Sigortası Ne Kadar?',
      content: [
        {
          paragraph:
            'Zorunlu deprem sigortası dairenin yüz ölçümü ve binanın bulunduğu risk bölgesine göre değişmektedir. Bu sebeple net bir fiyat söylemek mümkün değildir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta DASK Zorunlu Deprem Sigortası Online Nasıl Alınır?',
      content: [
        {
          paragraph:
            'Sürekli olarak gelişen internet dünyası pandemi döneminin etkisiyle neredeyse tamamen dijitale taşındı. Bu gelişme ile artık sigorta acenteleri müşterilerine daha hızlı bir hizmet verebilmek için online sigortacılığa geçmektedirler. ',
          subList: null
        },
        {
          paragraph:
            'Online teklif sigortalının ve konuta ait bilgiler ile form doldurulması üzerine sistem otomatik risk kriterlerine göre fiyat hesaplaması yapmaktadır. Kişi fiyatı uygun bulduğu takdirde online olarak sigortasını oluşturabilmektedir.',
          subList: null
        }
      ]
    }
  ]
}
